import React from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const showMoreOrLess = (isExpand) => isExpand
    ? { btnLabel: 'Show less', icon: <ExpandLessIcon /> }
    : { btnLabel: 'Show more', icon: <ExpandMoreIcon /> };
export default showMoreOrLess;
